export default {
    BASE_URL: '/paramConfig',
    api: [
        {
            name: 'appList',
            desc: '获取所属应用',
            method: 'GET',
            path: '/app/list'
        },
        {
            name: 'list',
            desc: '获取参数列表',
            method: 'GET',
            path: 'listConfigs'
        },
        {
            name: 'insert',
            desc: '新增参数',
            method: 'POST',
            path: 'save'
        },
        {
            name: 'update',
            desc: '更新参数',
            method: 'POST',
            path: 'edit'
        },
        {
            name: 'detail',
            desc: '获取参数详情',
            method: 'GET',
            path: 'getConfig/{id}'
        },
        {
            name: 'checkName',
            desc: '检查参数编码是否重复',
            method: 'GET',
            path: 'hasExist'
        },
        {
            name: 'toggle',
            desc: '启用/禁用参数',
            method: 'PUT',
            path: 'openOrCloseParam'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/api/system/setting/index.js